import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PanelList } from '../../../../../shared/models/panel-list';
import { ActionItemAuditTrialDetails } from '../models/action-item-audit-trial-details';
import { CommonService } from '../../../../../shared/services/common.service';
import { FilterMenu } from '../../../../../shared/models/filter-menu';
import { SortMenu } from '../../../../../shared/models/sort-menu';

@Component({
  selector: 'app-action-item-audit-summary',
  templateUrl: './action-item-audit-summary.component.html',
  styleUrls: ['./action-item-audit-summary.component.scss']
})
export class ActionItemAuditSummaryComponent {
  @Input() auditSummaryDetails!: ActionItemAuditTrialDetails[];
  @Output() attributeDetailsOfTransaction = new EventEmitter();
  isActionItemAuditSummaryLoaded: boolean = true;
  actionItemAuditSummaryInput: PanelList = {
    title: undefined,
    lists: [],
    enableFilter: true,
    enableSort: true,
    filters: [],
    sort: [],
    enableToggling: false,
    enableSelection: false,
    enablePanelCardClick: true,
    enablePanelHighLight:true
  };

  constructor(private commonService: CommonService) { }

  ngOnInit(): void {
    this.bindActionItemAuditSummary();
  }

  bindActionItemAuditSummary = () => {
    this.actionItemAuditSummaryInput.lists = this.auditSummaryDetails;
    this.actionItemAuditSummaryInput.filters = this.getFiltersForActionItemAuditList();
    this.actionItemAuditSummaryInput.sort = this.getSortFieldsForActionItemAuditList();
    this.actionItemAuditSummaryInput.clearSelection = true;
    this.isActionItemAuditSummaryLoaded = !this.commonService.IsListEmpty(this.auditSummaryDetails);
    this.actionItemAuditSummaryInput = { ...this.actionItemAuditSummaryInput };
  }
  private getFiltersForActionItemAuditList = (): FilterMenu[] => {
    let filters: FilterMenu[] = [];
    filters.push(
      {
        filterDisplayName: 'User',
        filterFieldName: 'user',
      },
      {
        filterDisplayName: 'Action',
        filterFieldName: 'action',
      }
    );
    return filters;
  };
  private getSortFieldsForActionItemAuditList = (): SortMenu[] => {
    let sortMenu: SortMenu[] = [];
    sortMenu.push(
      {
        sortFieldDisplayName: 'User',
        sortFieldName: 'user',
      },
      {
        sortFieldDisplayName: 'Action',
        sortFieldName: 'action',
      }
    );
    return sortMenu;
  };
  showAuditAttributeDetails = (data: any) => {
    this.attributeDetailsOfTransaction.emit(data);;
  }

}
